import React from 'react';
import '../components/game-views/GameViews/gameViews.css';
import '../components/game-views/GameViews/gameViewMedia.css';
import '../css/styles.css';
import { connect } from 'react-redux';
import { setInfo, setGameData } from '../redux/actionList';
import { Navigate } from 'react-router-dom';

import Config from '../config';
import ConfigFile from '../datasets/config_file';
import tooltipCommentIconText from './Text/tooltip_text';
import LinkTab from '../components/shared-components/link_tab';
import GameBoard from '../components/game-views/game-board';
import ChangeGameChoices from '../components/game-views/change_game_choices';
import ChangeSkillsSurvey from '../components/game-views/change_skills_survey';
import ChangeCareer from '../components/game-views/change_career';
import HomeChange from '../components/game-views/home_change';
import CarChange from '../components/game-views/car_change';
import UnlockedFeatures from '../components/game-views/unlocked_features';
import StatusDisplay from '../components/game-views/status_display';
import EndGame from '../components/end-game/end_game';
import CommentModal from '../components/shared-components/comment_modal';
import MoodRetirementStatusModal from '../components/game-views/mood_retirement_status_modal';
import WaitTimeSpinner from '../components/shared-components/wait_time_spinner';
import GameChoicePictures from '../components/game-views/game_choice_pictures.js';
import Footer from './footer';
import EarnBadge from '../components/game-views/earn_badge.js';

import beforeAfterCompare from '../objects/CommonUse/before_after_compare';
import getGameChoicePictures from './Objects/get_game_choice_pictures';

import { Link } from "react-router-dom";
import withRouterCompat from '../objects/CommonUse/with_router_compat';
import { Tooltip } from "@mui/material";
import { calculateMoodRetirementScores } from 
    '../components/game-views/objects/calculate_mood_retirement_scores';
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import { buildUrl } from '../objects/CommonUse/build_URL';
import { reconcileUnlockedFeatures } from '../components/game-views/objects/reconcile_unlocked_features';
import { resetPicturesForChanges } from '../components/game-views/objects/reset_pictureInfo_for_changes';
import { calcMonthlyIncome } from '../objects/CommonUse/calcMonthlyIncome';

import createInvestmentSummaryArr from './Objects/create_investment_summary_arr';
import retirement401KInfo from '../components/moneyBuilder/savings/datasets/retirement_401k_info';
import { calculateJobSalary } from '../objects/AssetsExpenses/calculate_job_salary';
import buildActiveFeatureArr from './Objects/build_active_feature_arr';
import calculateShortTermSavings from '../components/game-views/objectsHome/calculate_short_term_savings';
import updateSessionTokenStorage from './Objects/update_session_token_storage';
import MoodRetirementDisplay from './moodRetirementDisplay';
import determineCreditScore from '../components/game-views/objectsEndOfTurn/determine_credit_score';



// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    savingsInfo: state.savingsInfo,
    creditCardInfo: state.creditCardInfo,
    timeWizardInfo: state.timeWizardInfo,
    gameInvestments: state.gameInvestments,
    funStuffInfo: state.funStuffInfo,
    creditReport: state.creditReport,
    notificationArr: state.notificationArr
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    setGameDataRedux: setGameData
};

class GameView extends React.Component {
    constructor(props) {
        super(props);
    
        this.prevIndex = 0;
        this.openCommentModal = this.openCommentModal.bind(this);
        this.closeCommentModal = this.closeCommentModal.bind(this);

        this.state = {
            inputArr: [
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                },
                {
                    completed: false,
                    selected: false
                }
            ],
            nbrMonthsOfPlay: 0,
            modalOpen: false,
            commentIcon: "./assets/ContactUs/pencilPaper.png",
            commentModalOpen: false,
            fromProcessName: "GameView",
            username: null,
            moodRetirementOpen: false,
            screenSize: sessionStorage.getItem("GameScreenSize"),
            gameLoaded: false,
            eventConditionsLoaded: false,
            creditCardLoaded: false,
            savingsLoaded: false,
            funStuffLoaded: false,
            timeWizardLoaded: false,
            gamePurchasesLoaded: false,
            gameInvestmentsLoaded: false,
            friendsLoaded: false,
            headers: setHeadersForFetch(),
            environment: Config.dataURL.currentEnv,
            subProcess: "gameView",
            gameInfo:{},
            jobChoiceLoaded: false,
            carChoiceLoaded: false,
            homeChoiceLoaded: false,
            displayInvestmentDetail: false,
            modalStyle: {},
            rerender: false,
            pendingNavigation: false,      
            moodRotation: 0,
            retirementRotation: 0,
            moodEmoji: "",
            redirect: null, 
            earnBadge: false
        };

        switch(props.selected) {
            case "gameBoard":
                this.inputSelected(0);
                break;
            case "gameChoices":
                this.inputSelected(1);
                break;
            case "unlockedFeatures":
                this.inputSelected(2);
                break;
            case "statusDisplay":
                this.inputSelected(3);
                break;
            case "endGame":
                this.inputSelected(4);
                if (!this.endGameReason){
                    this.endGameReason = "PlayersChoice";
                }
                break;
            default:
                break;
        }
        this.previousProcess = "GameView";
        this.allDataLoaded = false;
        this.totalNbrGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
        this.setGameInfo(this.totalNbrGameMonths, "totalGameMonths");
        this.readyToLoadPictures = false;
        this.prevProcess = "";
        this.selected = "";
      }

   
    onNavigate = (path) => {
        const { navigate, location } = this.props;
        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };

   
      render() {
         
          if (this.allDataLoaded === false){
            if (this.state.gameLoaded === true && this.state.friendsLoaded === true &&
                this.state.creditCardLoaded === true && this.state.eventConditionsLoaded === true &&
                this.state.funStuffLoaded === true && this.state.savingsLoaded === true &&
                this.state.timeWizardLoaded === true && this.state.gamePurchasesLoaded === true && 
                this.state.gameInvestmentsLoaded === true && this.props.gameInfo.pictureInfo.jobID ){
                    this.gameInfoDisplay=this.state.gameInfo;
                    this.allDataLoaded = true;
            }
        }
        if (this.allDataLoaded === true &&
           this.props.selected === "moneyBuilderPassThru"){
                 return (
                     <Navigate to="/conductor-dashboard" replace={true} />
                 );
        }

        if (this.selected !== this.props.selected){
            updateSessionTokenStorage(this.props.selected);
            this.selected = this.props.selected;
        }
     
                   
    return <>
        <span className="container m-0 p-0">
        <span className="row w-100 mx-0">
            <div className="col-sm-2">
                <div className=" mt-4">
                    {this.readyToLoadPictures ?
                        <div>
                            <GameChoicePictures 
                                pictureInfo={this.props.gameInfo.pictureInfo}
                            />
                        </div>
                    :
                        null
                    }
                </div>
            </div>
            {!this.allDataLoaded ? 
                <div className="col-sm-8 input-page-base-card game-board-narrow">
                    <WaitTimeSpinner/>
                </div>
            :
                null
            }
   
            {this.state.moodRetirementOpen  ?
                <div>
                    <MoodRetirementStatusModal 
                        modalOpen={this.state.moodRetirementOpen} 
                        onClose={() => this.closeMoodRetirementModal()}
                    />
                </div> 
            :
                null
            }

            <div>
                <Tooltip title={tooltipCommentIconText} arrow >
                    <img src={this.state.commentIcon} 
                        className="gameView-comment-icon-position comment-img cursor-is-pointer" 
                        alt="comment"
                        onClick={this.openCommentModal}/>
                </Tooltip>
            </div> 

            {this.state.commentModalOpen ?
                    <CommentModal modalOpen={this.state.commentModalOpen} 
                        onClose={() => this.closeCommentModal()}
                        gamePart={this.state.fromProcessName}
                        processName={this.props.selected}
                        btnText={this.btnText}
                        gameInfo = {() => this.getGameInfo()}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    />
                :
                    null
                }
                        
                {this.props.selected === "gameBoard"  &&
                    this.allDataLoaded ? 
                    <GameBoard completed={() => this.inputCompleted(0)}
                        onOpen ={()=> this.inputSelected(0)} 
                        onEnd={(endGameReason) => this.endGame(endGameReason)}
                        homeChangeEnable = {()=> this.inputUncompleted(1)}
                        carChangeEnable= {()=> this.inputUncompleted(2)}
                        openMoodRetirement={this.state.moodRetirementOpen}
                        closeMoodRetirementModal={()=> this.closeMoodRetirementModal()}
                        gameInfo = {() => this.getGameInfo()} 
                        moodEmoji = {this.state.moodEmoji}
                        screenSize={this.state.screenSize}
                        previousProcess={this.previousProcess}
                        totalNbrGameMonths={this.totalNbrGameMonths}
                        calcMoodRetirementScores={() => this.calcMoodRetirementScores()}
                        onNavigate={(pathName) => this.onNavigate(pathName)}
                        updateInvestmentSummary = {() => this.getMonthlyInvestmentPrices()}
                        setGameInfo = {(value, propertyName, subPropertyName) => 
                            this.setGameInfo(value, propertyName, subPropertyName)}
                        checkDataAccuracy = {(dataObj) => this.checkDataAccuracy(dataObj)}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    /> : <span/>}

                    {this.props.selected === "gameChoices"  && 
                        this.allDataLoaded ? 
                            <ChangeGameChoices 
                                completed={() => this.inputCompleted(1)}
                                onOpen ={()=> this.inputSelected(1)} 
                                gameInfo = {() => this.getGameInfo()}
                                onNavigate={(pathName) => this.onNavigate(pathName)}
                                setGameInfo = {(value, propertyName, subPropertyName) => 
                                    this.setGameInfo(value, propertyName, subPropertyName)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                    : <span/>}
                            
                    {this.props.selected === "changeSkillsSurvey" &&
                        this.allDataLoaded ? 
                        <ChangeSkillsSurvey 
                            gameInfo = {()=> this.getGameInfo()}
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            setGameInfo = {(value, propertyName, subPropertyName) => 
                                this.setGameInfo(value, propertyName, subPropertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            /> 
                    : <span/>}
                    {this.props.selected === "changeCareer"  &&
                        this.allDataLoaded ?  
                        <ChangeCareer
                            onOpen={()=>this.inputSelected(1)}
                            onChangeComplete ={()=> this.setPrevProcess("jobChange")} 
                            gameInfo = {() => this.getGameInfo()} 
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            setGameInfo = {(value, propertyName, subPropertyName) => 
                                this.setGameInfo(value, propertyName, subPropertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    : <span/> }                               
                    {this.props.selected === "changeHome"  &&
                        this.allDataLoaded ? 
                        <HomeChange 
                            onChangeComplete ={()=> this.setPrevProcess("homeChange")} 
                            gameInfo = {() => this.getGameInfo()}
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            setGameInfo = {(value, propertyName, subPropertyName) => 
                                    this.setGameInfo(value, propertyName, subPropertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                    : <span/>}
                    {this.props.selected === "changeCar" &&
                        this.allDataLoaded ?  
                        <CarChange 
                            onChangeComplete ={()=> this.setPrevProcess("carChange")} 
                            gameInfo = {() => this.getGameInfo()} 
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            setGameInfo = {(value, propertyName, subPropertyName) => 
                                    this.setGameInfo(value, propertyName, subPropertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        : <span/>}
                  
                    {((this.props.selected === "unlockedFeatures" || this.props.selected === "setupSavings" ||
                        this.props.selected === "setupCreditCard"  || this.props.selected === "setupFunStuff" ||
                        this.props.selected === "setupTimeWizard" )  &&
                        this.allDataLoaded) ?  
                        <UnlockedFeatures 
                            selected={this.props.selected}
                            totalNbrGameMonths={this.totalNbrGameMonths}
                            completed={() => this.inputCompleted(1)}
                            onOpen ={()=> this.inputSelected(2)} 
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            checkUnlockedFeatures = {() => this.checkAndValidateUnlockedFeatures()}
                            resetTotalNbrGameMonths={(totalNbrGameMonths) => 
                                this.resetTotalNbrGameMonths(totalNbrGameMonths)}
                            setGameInfo = {(value, propertyName, subPropertyName) => 
                                this.setGameInfo(value, propertyName, subPropertyName)}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        : <span/>}
                                  
                    {(this.props.selected === "statusDisplay" || 
                        this.props.selected === "monthlyStatus")  &&
                        this.allDataLoaded ?  
                        <StatusDisplay
                            selected={this.props.selected}
                            onOpen ={()=> this.inputSelected(3)}
                            onNavigate={(pathName) => this.onNavigate(pathName)}
                            prevProcess={this.prevProcess}
                            gameInfo = {() => this.getGameInfo()} 
                            clearPrevProcess ={()=> this.setPrevProcess("clear")}
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            /> 
                        : <span/>}

                    {this.props.selected === "earnBadge" ?
                         <EarnBadge
                                openChallenge={this.state.earnBadge}
                                gameInfo = {() => this.getGameInfo()}
                                onFinish={(badgeObj) => this.finishBadgeProcess(badgeObj)}
                                onClose={() => this.closeBadge()}
                                onNavigate={(pathname) => this.onNavigate(pathname)}
                                setGameInfo = {(value, propertyName, subPropertyName) => 
                                    this.setGameInfo(value, propertyName, subPropertyName)}
                                processError = {(errorObj) => this.processErrorReturn(errorObj)}
                            />
                            : <span/>    
                    }
                 
                    {this.props.selected ==="endGame"   &&
                        this.allDataLoaded ? 
                        <EndGame
                            totalNbrGameMonths={this.totalNbrGameMonths}    
                            endGameReason={this.endGameReason}
                            activityCategory={this.state.gameInfo.activityCategory}
                            onOpen ={()=> this.inputSelected(4)}
                            onNavigate={(pathname) => this.onNavigate(pathname)}
                            completed={() => this.inputCompleted(4)}
                            gameInfo = {() => this.getGameInfo()} 
                            processError = {(errorObj) => this.processErrorReturn(errorObj)}
                        />
                        : <span/>    
                    }

                {!this.props.selected ? 
                    <div className="col-sm-6 ml-0 input-page-base-card">
                    <div className="card mt-3 mr-5 rounded-corners-lg text-center"></div></div> 
                : <span/>}
  
        <div className="col-sm-2 mt-1">
        
                <MoodRetirementDisplay
                    moodRotation={this.state.moodRotation}
                    retirementRotation={this.state.retirementRotation}
                    openMoodRetirementModal={() => this.openMoodRetirementModal()}
                />
                {!this.state.inputArr[0].completed ?
                    <Link to="/game-board" onClick={() => this.handleClick(0)}>
                        <LinkTab inputArr={this.state.inputArr[0]} name="Game Board" validToComplete="true" 
                            />
                    </Link>
                :
                    <LinkTab inputArr={this.state.inputArr[0]} name="Game Board" />
                }           
                    {!this.state.inputArr[1].completed ?
                    <Link to="/game-choices" onClick={() => this.handleClick(1)}>
                        <LinkTab inputArr={this.state.inputArr[1]} name="Change Game Choices" 
                            validToComplete="true"  />
                    </Link>
                :
                    <LinkTab inputArr={this.state.inputArr[1]} name="Change Game Choices"
                            />
                }                                       
                {!this.state.inputArr[2].completed ?
                    <Link to="/unlocked-features" onClick={() => this.handleClick(2)}>
                        <LinkTab inputArr={this.state.inputArr[2]} name="Unlocked Features" 
                            validToComplete="true"  />
                    </Link>
                :
                    <LinkTab inputArr={this.state.inputArr[2]} name="Unlocked Features"
                             />
                }                 
                {!this.state.inputArr[3].completed ?
                    <Link to="/status-display" onClick={() => this.handleClick(3)}>
                        <LinkTab inputArr={this.state.inputArr[3]} name="How am I Doing?" 
                            validToComplete="true" />
                    </Link>
                :
                    <LinkTab inputArr={this.state.inputArr[3]} name="How am I Doing?" 
                             />
                }                                     
                                            
                <Link to="/end-game" onClick={() => this.endGame()}>
                    <LinkTab inputArr={this.state.inputArr[4]} name="Finish Game" 
                        validToComplete="true" />
                </Link>
                    {/* copyright for zoom/ipad - footer not visible in these layouts */}
                {(this.state.screenSize === "zoom") &&
                    <Footer 
                        screenSize={this.state.screenSize}
                    />
                }
            </div>
        </span>
        {/*
                 {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
        */}
        </span>
               
        </>
    }
    
    componentDidMount(){
        this._isMounted = true;
         
        document.querySelectorAll('*').forEach(el => {
        if (el.scrollHeight > window.innerHeight) {
            console.log('Tall element:', el.tagName, el.className, el.id, 'scrollHeight:', el.scrollHeight, 'innerHeight:', window.innerHeight);
        }
        });

        this.inputSelected(0);
        const gameInfo = this.props.gameInfo;
        this.gameData = gameInfo.gameData;
        this.retirementPriceArr = gameInfo.retirementPriceArr;
        this.eventConditions = gameInfo.eventConditions;
        this.timeWizardInfo = this.props.gameInfo.timeWizardInfo;
        if (this.timeWizardInfo.status && this.timeWizardInfo.status === "active"){
           this.totalNbrGameMonths = (this.timeWizardInfo.gameNbrYears * 12).toFixed(0);
           this.setGameInfo(this.totalNbrGameMonths, "totalGameMonths")
        }
        console.log("DidMount totalNbrGameMonths: ", this.totalNbrGameMonths);
        this.currentGameMonth = +this.totalNbrGameMonths - +this.gameData.gameNbrMonths;
        console.log("current game month is: ", this.currentGameMonth);
        this.gameInvestments = gameInfo.gameInvestments;
        this.funStuffInfo = gameInfo.funStuffInfo;
        this.refreshInvestments = gameInfo.refreshInvestments;
        this.setState({gameInfo: gameInfo});
        if (gameInfo.allDataLoaded === false){
            this.checkIfRefreshRequired(gameInfo);
            this.refreshGameInfo();
        }else{
            if (gameInfo.refreshInvestments === true){
                this.readyToLoadPictures = true;
                this.setState({gameLoaded: true, eventConditionsLoaded: true, friendsLoaded: true, 
                    savingsLoaded: true, creditCardLoaded: true, 
                    funStuffLoaded: true, timeWizardLoaded: true, 
                    gamePurchasesLoaded: true, investmentMasterLoaded: false })
                const gameDataID = gameInfo.gameData._id;
                this.loadGameInvestments(gameDataID);
            }else{
                this.allDataLoaded = gameInfo.allDataLoaded;
                this.readyToLoadPictures = true;
            }
        }
        const creditReport = determineCreditScore(gameInfo.creditCardInfo, 
                gameInfo.gameData.loanTable, gameInfo.gameData.currentGameDate,
                gameInfo.gameData.gameNbrMonths, this.props.timeWizardInfo );
        this.props.setInfoRedux(creditReport, "creditReport");
        if (this.props.selected !== "gameBoard"){
            this.previousProcess = this.props.selected;
        }
    }

    checkIfRefreshRequired(gameInfo){
        const currentGameID = this.gameData._id;
        let skipFunStuffLoad = false;
        let skipSavingsLoad = false;
        let skipCreditCard = false;
        let skipGameInvestmentsLoad = false;
        let skipGamePurchasesLoad = false;
        let skipTimeWizardLoad = false;
        if (gameInfo.funStuffInfo.gameID === currentGameID){
            skipFunStuffLoad = true;
        }
        this.eligibleForRetirementSavings = false;
        const featureObj = gameInfo.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        if (featureObj && featureObj.level >= 2){
            this.eligibleForRetirementSavings = true;
        }
        if (gameInfo.savingsInfo.gameID === currentGameID){
            if (this.eligibleForRetirementSavings === true){
                if (this.retirementPriceArr.length > 0){
                    skipSavingsLoad = true;
                }
            }else{
                skipSavingsLoad = true;
            }
        }
        if (gameInfo.creditCardInfo.gameID === currentGameID){
                skipCreditCard = true;
        }
        if (gameInfo.gameInvestments.length > 0 &&
            gameInfo.gameInvestments[0].gameID === currentGameID){
            skipGameInvestmentsLoad = true;
        }
        if (gameInfo.gamePurchases.gameID === currentGameID){
            skipGamePurchasesLoad = true;
        }
        if (gameInfo.timeWizardInfo.gameID === currentGameID){
            skipTimeWizardLoad = true;
        }
        this.skipLoad = {skipFunStuff: skipFunStuffLoad, skipSavings: skipSavingsLoad,
            skipCreditCard: skipCreditCard, skipGameInvestments: skipGameInvestmentsLoad, 
            skipGamePurchases: skipGamePurchasesLoad, skipTimeWizard: skipTimeWizardLoad }
    }

    inputSelected = (inputID) => {
        let inputArr = this.state.inputArr;
        for (const input of inputArr) {
            input.selected = false;
        }
        inputArr[inputID].selected = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr});
        }
    };

    componentWillUnmount(){
        console.log("GameView is unmounting");
        if (this.allDataLoaded === true && this.props.selected !== "endGame"){
            this.props.setInfoRedux(true, "allDataLoaded");
        }
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    calcMoodRetirementScores(){
        let savings = 0;
        if (this.state.gameInfo.savingsInfo.totalSavingsAmt){
             savings = this.state.gameInfo.savingsInfo.totalSavingsAmt;
        }
        let totalInvestments = 0;
        if (this.state.gameInfo.summaryInvestment.length > 0){
            const summaryInvestments = this.state.gameInfo.summaryInvestment;
            totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
        }
        let rotationObj = calculateMoodRetirementScores(this.state.gameInfo.gameData.currentMoodPoints,
            this.state.gameInfo.gameData.currentCash, savings, totalInvestments,
            this.state.gameInfo.gameData.assetTable, this.state.gameInfo.gameData.currentGameDate);
           
        this.setState({moodRotation: rotationObj.moodRotation, 
            retirementRotation: rotationObj.retirementRotation,
            moodEmoji: rotationObj.emojiURL});
    }

    openCommentModal(){
        this.btnText = sessionStorage.getItem("gameBtnText");
        this.setState({commentModalOpen: true});
    }

    closeCommentModal(){
        this.setState({commentModalOpen: false});
    }
        
    handleClick = index => {
        this.inputSelected(index);
    }

    configurationAvailable()
    {
        return false;
    }

    setupPortfolioDetailDisplay(investObj){
        this.transactionArr = investObj.transactionArr;
        this.totalBuyArr = investObj.totalBuyArr;
        this.setState({displayInvestmentDetail: true})
    }

    finishBadgeProcess(badgeObj){
   //     const lastIndx = badgeObj.badgesEarned.length - 1;
   //     const newBadgeObj = badgeObj.badgesEarned[lastIndx];
   //     const notificationObj = 
   //         addCelebrationToNotificationArr(newBadgeObj.badgeCode, "badge", "", newBadgeObj);  
   //     this.notificationArr = [notificationObj];
   //     this.openNotificationModal();
   //     this.setState({earnBadge: false,  cardDisabled: false}); 
    }

    closeBadge(){
        this.setState({earnBadge: false});
    }
    
    setPrevProcess(type)
    {
        if (type === "jobChange" || type === "carChange" || type === "homeChange"){
            this.checkAndValidateUnlockedFeatures();
            this.prevProcess = "ChangeGameChoices";
        }else{
            this.prevProcess = "";
        }
    }

    checkAndValidateUnlockedFeatures(){
        if (this.state.gameInfo.gameData.gameTemplate === "unlocked"){
            //  do not update unlocked features if game was created with this template
        }else{
            let activeFeatureArr = buildActiveFeatureArr(this.props.savingsInfo,
                this.props.gameInvestments, this.props.creditCardInfo, this.props.timeWizardInfo,
                this.props.funStuffInfo);
            let monthlyAmounts=calcMonthlyIncome(this.props.gameData.assetTable, 
                this.props.gameData.expenseTable, this.props.gameData.loanTable);
            this.monthlyIncome = monthlyAmounts.income;
            const annualSalary = calculateJobSalary(this.props.gameData.assetTable, 
                this.props.gameData.currentGameDate, false, "annual");
            let cashAmt = +JSON.stringify(JSON.parse(+this.props.gameData.currentCash));
            let savingsAmt = 0;
            if (this.props.savingsInfo.gameID){
                savingsAmt = calculateShortTermSavings(this.props.savingsInfo);
            }
            cashAmt += +savingsAmt;
            const unlockedFeatureObj = reconcileUnlockedFeatures(this.props.gameData.gameNbrMonths,
                cashAmt, this.monthlyIncome, this.props.gameData.unlockedFeatures, 
                activeFeatureArr, this.totalNbrGameMonths, annualSalary, this.props.creditReport);
            if (unlockedFeatureObj.changed === true){
                this.unlockedFeatures = unlockedFeatureObj.unlockedFeatures;
                this.updateUnlockedFeatures();
            }
        }
    }
       
    openMoodRetirementModal(){
        this.setState({moodRetirementOpen: true});
    }

    closeMoodRetirementModal(){
        this.setState({moodRetirementOpen: false});
    }

    endGame(endGameReason)
    {
        this.handleClick(4);
        this.endGameReason = endGameReason;
        if (!this.endGameReason){
            this.endGameReason = "PlayersChoice"
        }
        if (this.endGameReason === "NegativeCash" ||
            this.endGameReason === "NegativeMoodPoints" ||
            this.endGameReason === "TimeElapsed"){
            let inputArr = this.state.inputArr;
            for (var i=0; i<4; i++){
                inputArr[i].completed = true;
            }
            this.setState({inputArr: inputArr});
        }
    }

    closeOutGame()
    {
        // Migrate current cash position to leaderboard (need to set up Node endpoint for this)
        // right now this code will never be executed
        this.onNavigate("");
    }

    resetTotalNbrGameMonths(totalNbrGameMonths){
        this.totalNbrGameMonths = totalNbrGameMonths;
        this.setGameInfo(this.totalNbrGameMonths, "totalGameMonths");
    }

    getGameInfo()
    {
        if (this._isMounted === true){
            this.setState({gameInfo: this.props.gameInfo});
        }
        return this.props.gameInfo;
    }

    setGameInfo(value, propertyName = null, subPropertyName)
    { 
        if (propertyName ){
            if (subPropertyName ){
                this.props.setGameDataRedux(value, subPropertyName);
            }else{
               this.props.setInfoRedux(value, propertyName);
            }
            if (this._isMounted === true){
                this.setState({gameInfo: this.props.gameInfo});
            }
        }else{
            const errorObj={function: "SetGameInfo", subProcess: this.state.subProcess, 
                status: 999, message: "propertyName is undefined", errorObject: value,
                silentAlert: true};
            this.processErrorReturn(errorObj);
        }
    } 

    //  add initial fetches required for game processes....

    refreshGameInfo(){
        this.setState({gameLoaded: false, eventConditionsLoaded: false,
                savingsLoaded: false, creditCardLoaded: false, funStuffLoaded: false, 
                timeWizardLoaded: false, friendsLoaded: false, gamePurchasesLoaded: false,
                investmentMasterLoaded: false
        })
        this.loadGameRelatedInfo();
        if (this.eventConditions.length === 0){
            this.loadEventConditions();
        }else{
            this.setState({eventConditionsLoaded: true});
        }
    }

    loadGameRelatedInfo() {
        this.checkForUnlockedFeatures();
        this.loadJob();
        this.loadHome();
        this.loadCar();
        this.loadFriends();
        this.setState({gameLoaded: true});
    }
 
    checkForUnlockedFeatures(){
        let funStuffLoaded = false;
        let savingsLoaded = false;
        let creditCardLoaded = false;
        let timeWizardLoaded = false;
        let gameInvestmentsLoaded = false;
        
        const unlockedFeatureFunStuff = 
            this.gameData.unlockedFeatures.find(elem => elem.featureName === "funStuff");
        if (unlockedFeatureFunStuff &&
            this.skipLoad.skipFunStuff === false ){
            funStuffLoaded = true;
            this.loadFunStuff(this.gameData._id);
        }
        const unlockedFeatureSavings = 
            this.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        if (unlockedFeatureSavings &&
            this.skipLoad.skipSavings === false){
            savingsLoaded = true;
           
        }
        const unlockedFeatureCreditCard =
            this.gameData.unlockedFeatures.find(elem => elem.featureName === "creditCard");
        if (unlockedFeatureCreditCard
            && this.skipLoad.skipCreditCard === false ){
            creditCardLoaded = true;
            this.loadCreditCard(this.gameData._id);
        }
        const unlockedFeatureInvestments =
                this.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        if ((unlockedFeatureInvestments &&
            unlockedFeatureInvestments.level === 3 &&
            unlockedFeatureInvestments.setup !== "none" &&
            this.skipLoad.skipGameInvestments === false) ||
            this.refreshInvestments === true){ 
                 gameInvestmentsLoaded = true;
        }
        const unlockedFeatureTimeWizard =
            this.gameData.unlockedFeatures.find(elem => elem.featureName === "timeWizard");
        if (unlockedFeatureTimeWizard
            && this.skipLoad.skipTimeWizard === false ){
                timeWizardLoaded = true;
                // ensure that timeWizard is fully loaded before gameInvestments are loaded
                this.loadTimeWizardAsync(gameInvestmentsLoaded, savingsLoaded);
        }else{
            if (savingsLoaded === true){
                this.loadSavings(this.gameData._id);
            }
            if (gameInvestmentsLoaded === true){
                this.loadGameInvestments(this.gameData._id);
            }
        }
        if (funStuffLoaded === false){
            if (this.funStuffInfo !== undefined && this.funStuffInfo.gameID !== undefined){
                //  gameInfo.funStuffInfo will be valid if game restored
                this.buildGamePicturesObj("funStuff", this.funStuffInfo);
            }else{
                this.buildGamePicturesObj("funStuff", "");
            }
            this.setState({funStuffLoaded: true});
        }
        if (savingsLoaded === false){
            this.setState({savingsLoaded: true});
        }
        if (creditCardLoaded === false){
            this.setState({creditCardLoaded: true});
        }
        if (timeWizardLoaded === false){
            this.setState({timeWizardLoaded: true});
        }
        if (gameInvestmentsLoaded === false){
            this.setState({gameInvestmentsLoaded: true});
        }
        if (this.skipLoad.skipGamePurchases === false){
            this.loadGamePurchases(this.gameData._id);
        }else{
            this.setState({gamePurchasesLoaded: true});
        }
     
    }

    async loadTimeWizardAsync(loadGameInvestments, loadSavings){
        await this.loadTimeWizard(this.gameData._id);
        if (this.timeWizard && this.timeWizard.status !== "inactive"){
            this.totalNbrGameMonths = (+this.timeWizard.gameNbrYears * 12).toFixed(0);
            this.setGameInfo(this.totalNbrGameMonths, "totalGameMonths");
            console.log("timeWizard totalNbrGameMonths ", this.totalNbrGameMonths);
            this.currentGameMonth = +this.totalNbrGameMonths - +this.gameData.gameNbrMonths;
            console.log("current game month is: ", this.currentGameMonth);
        }
        // insure that the current game month has been set before loading savings or game investments
        if (loadSavings === true){
            this.loadSavings(this.gameData._id);
        }
        if (loadGameInvestments === true){
            this.loadGameInvestments(this.gameData._id);
        }
    }
    
    loadEventConditions() {
        const funcName = "eventConditionsList";
        const urlParm = "?triggeredByList=monthly,event,funStuff";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.setGameInfo(output.body, 'eventConditions');
                        this.setState({eventConditionsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            });
    }

    loadSavings(gameID) {
        const funcName = "loadSavings";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.savings = output.body;
                        this.setGameInfo(this.savings, "savingsInfo");
                        if (this.eligibleForRetirementSavings === true){
                            this.getRetirementSavingPrices();
                        }else{
                            this.setState({savingsLoaded: true});
                        }
                    }else{
                        if (statusCode === 250){
                            // there is no savings for this player;
                            this.setState({savingsLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }
    
    async getRetirementSavingPrices(){
        const retirementPriceArr = this.props.gameInfo.retirementPriceArr;
        let companyMatchRate = this.props.gameInfo.companyMatchRate;
        if (+companyMatchRate === 0){
            companyMatchRate = this.savings.companyMatchRate;
        }
        this.setGameInfo(companyMatchRate, "companyMatchRate")
        if (retirementPriceArr.length === 0){
            this.retirementShortNameArr = [];
            const retirement401KAccountList = retirement401KInfo;
            for (let i=0; i<retirement401KAccountList.length; i++){
                const retirementObj = retirement401KAccountList[i];
                this.retirementShortNameArr.push(retirementObj.shortName);
            }       
            this.startMonthNbr = this.currentGameMonth;
            const totalGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
            this.endMonthNbr = +totalGameMonths;
            const retirementPriceData = await this.loadInvestmentMonthly("retirement");
            let retirementPriceArr = [];
            for (let i=0; i<retirementPriceData.length; i++){
                const retirementPriceObj = {retirementType: retirementPriceData[i].investShortName, 
                    monthNbr: retirementPriceData[i].monthNbr,
                    currentPrice: retirementPriceData[i].closingPrice }
                retirementPriceArr.push(retirementPriceObj);
            }
            // loading straight to redux as this is a large amount of data and isn't required
            // for most of the gameInfo processes
            this.props.setInfoRedux(retirementPriceArr, "retirementPriceArr");
        }
        this.setState({savingsLoaded: true});
    }
    
    loadCreditCard(gameID) {
        const funcName = "loadCreditCardInfo";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        let creditCard = output.body;
                        this.setGameInfo(creditCard, "creditCardInfo")
                        this.setState({creditCardLoaded: true});
                    }else{
                        if (statusCode === 250){
                             // there is no credit card record for this player
                             this.setState({creditCardLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }
            
    loadFunStuff(gameID) {
        const funcName = "loadFunStuff";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        let funStuff = output.body;
                        this.setGameInfo(funStuff, "funStuffInfo");
                        this.buildGamePicturesObj("funStuff", funStuff);
                        this.setState({funStuffLoaded: true});
                    }else{
                        if (statusCode === 250){
                               // there is no credit card record for this player
                               this.buildGamePicturesObj("funStuff", "");
                               this.setState({funStuffLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }
      
   async loadTimeWizard(gameID) {
        const funcName = "loadTimeWizard";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        try {
            const response = await fetch(uri, {
                method: 'GET',
                headers: this.state.headers
            });
                const data = await response.json();
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200) {
                    this.timeWizard = output.body;
                    this.setGameInfo(this.timeWizard, "timeWizardInfo");
                    this.setState({ timeWizardLoaded: true });
                } else if (statusCode === 250) {
                    // there is no time wizard record for this player
                    this.setState({ timeWizardLoaded: true });
                } else {
                    const errorObj = {
                        function: funcName,
                        subProcess: this.state.subProcess,
                        status: statusCode,
                        message: output.body.message
                    };
                    this.processErrorReturn(errorObj);
                }
        } catch (error) {
            console.error(`${funcName} failed:`, error);
            this.processErrorReturn({
                function: funcName,
                subProcess: this.state.subProcess,
                status: 'FETCH_ERROR',
                message: error.message
            });
        }
    }
    
    loadJob(){
        const funcName = "jobInfo";
        let jobID = this.gameData.jobInfo.careerID;
        const urlParm = "?jobId=" + jobID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.jobChoiceData = output.body;
                        this.buildGamePicturesObj("job", this.jobChoiceData);
                        this.setState({jobChoiceLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    loadHome(){
        const funcName = "homeInfo";
        let homeID = this.gameData.homeInfo.homeID;
        const urlParm = "?homeId=" + homeID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.homeChoiceData = output.body;
                        this.buildGamePicturesObj("home", this.homeChoiceData);
                        this.setState({homeChoiceLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    loadCar(){
        const funcName = "carInfo";
        let carID = this.gameData.carInfo.carID;
        const urlParm = "?carId=" + carID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.carChoiceData = output.body;
                        this.buildGamePicturesObj("car", this.carChoiceData);
                        this.setState({carChoiceLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }
    

    buildGamePicturesObj(dataType, dataObj){
        switch (dataType){
            case "job":
                this.pictureInfoObj = getGameChoicePictures(dataType, dataObj, 
                   this.state.gameInfo.gameData.jobInfo, this.pictureInfoObj);
                break;
            case "car":
                this.pictureInfoObj = getGameChoicePictures(dataType, dataObj, 
                    this.state.gameInfo.gameData.carInfo, this.pictureInfoObj);
                break;
            case "home":
                this.pictureInfoObj = getGameChoicePictures(dataType, dataObj,  
                    this.state.gameInfo.gameData.homeInfo, this.pictureInfoObj);
                break;
            case "funStuff":
                this.pictureInfoObj = getGameChoicePictures(dataType, 
                    dataObj, "", this.pictureInfoObj);
                this.funStuffPictureLoaded = true;
                break;
            default:
                break;
        }
        if (this.pictureInfoObj.jobID  && this.pictureInfoObj.carID  &&
            this.pictureInfoObj.homeID  && 
            this.pictureInfoObj.funStuffInfo ){
                this.setGameInfo(this.pictureInfoObj, "pictureInfo");
                this.readyToLoadPictures = true;
        }
    }
       
    loadGamePurchases(gameID) {
        const funcName = "loadGamePurchases";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        let gamePurchases = output.body;
                        this.setGameInfo(gamePurchases, "gamePurchases");
                        this.setState({gamePurchasesLoaded: true});
                    }else{
                        if (statusCode === 250){
                             // there is no credit card record for this player
                             this.setState({gamePurchasesLoaded: true});
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }

    addFunStuffToPictureInfo() {
        //   this just makes sure that the funstuff picture info has been updated (if not done in game choice pictures)
        if (!this.state.gameInfo.pictureInfo.funStuffInfo.funStuffExists ||
            this.state.gameInfo.pictureInfo.funStuffInfo.funStuffExists === false) {
            const pictureInfoObj = resetPicturesForChanges("funStuff", this.state.gameInfo.pictureInfo, 
                "", "", "", this.state.gameInfo.funStuffInfo );
            this.setGameInfo(pictureInfoObj, 'pictureInfo');
        }
    }

    loadFriends() {
        const funcName = "loadFriends";
        let friendArr = [];
        const friendList = this.gameData.friendList;
        for (let i = 0; i < friendList.length; i++) {
            let friendName = friendList[i].name;
            friendArr.push(friendName);
        }
        const friendParm = friendArr.join(',');
        const urlParm = "?friendArr=" + friendParm;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.buildFriendInfoArr(output.body);
                        this.setState({friendsLoaded: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message}
                        this.processErrorReturn(errorObj);
                    }
                });
            });
    }
    
    buildFriendInfoArr(friendData) {
        let friendArr = [];
        let startIdx = friendData.length - 1;
        for (let i = startIdx; i >= 0; i--) {
            let friendImgURL = './assets/friends/' + friendData[i].friendImg
            let friendObj = {
                friendName: friendData[i].friendName, friendImgURL: friendImgURL,
                weightedOdds: friendData[i].weightedOdds
            };
            friendArr.push(friendObj);
        }
        this.setGameInfo(friendArr, "friendInfo");
    }
       
    loadGameInvestments(gameID) {
        //  right now this is only going to load 'stock' investments... but.... you can send multiple
        //  investment 'types' and get all types back from a single call.
        const funcName = "loadGameInvestments";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => {
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameInvestments = output.body;
                    //   this.setGameInfo(this.gameInvestments, "gameInvestments");
                        this.createArrayOfShortNames();
                    }else{
                        if (statusCode === 250){
                            this.gameInvestments = [];
                            if (this._isMounted === true){
                                this.setState({gameInvestmentsLoaded: true});
                            }
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message, errorObject: urlParm};
                            this.processErrorReturn(errorObj);
                        }
                    }
                });
            });
    }

    createArrayOfShortNames(){
        this.investShortNameArr = [];
        for (let i=0; i<this.gameInvestments.length; i++){
            const tranLength = this.gameInvestments[i].transactionArr.length;
            const gameInvestment = this.gameInvestments[i];
            for (let j=0; j<tranLength; j++){
                const transaction = gameInvestment.transactionArr[j];
                const shortName = transaction.investShortName;
                if (!this.investShortNameArr.includes(shortName)){
                    this.investShortNameArr.push(shortName);
                }
            }
        }
        this.setGameInfo(this.investShortNameArr, "shortNameArr");
        this.loadInvestmentMasters();
    }
  
    loadInvestmentMasters(){
        const funcName = "investmentMasterList";
        const shortNameList = this.investShortNameArr.join(",");
        const urlParm = "?queryType=shortName&investShortName=" + shortNameList;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
                {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.investmentMasterArr = output.body;
                        this.getMonthlyInvestmentPrices();
                        if (this._isMounted === true){
                            this.setState({investmentMasterLoaded: true});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: urlParm};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
    }

    async getMonthlyInvestmentPrices(){
        this.startMonthNbr = this.currentGameMonth;
        this.endMonthNbr = this.currentGameMonth;
        if (!this.investShortNameArr || this.investShortNameArr.length === 0){
            this.investShortNameArr = this.props.gameInfo.shortNameArr;
        }
        this.investmentMonthlyData = await this.loadInvestmentMonthly("investments");
        this.getCurrentPriceForInvestments();
    }
  
    async loadInvestmentMonthly(rqstType) {
        const funcName = "investmentMonthlySelect";
        this.gameInvestBehavior = "1";
        let shortNameList = "";
        if (rqstType === "investments"){       
            shortNameList = this.investShortNameArr.join(',');
        }else{
            shortNameList = this.retirementShortNameArr.join(',');
        }
        const urlParm = "?investShortName=" + shortNameList +
                        "&behavior=" + this.gameInvestBehavior +
                        "&startMonthNbr=" + this.startMonthNbr +
                        "&endMonthNbr=" + this.endMonthNbr;

        const uri = buildUrl(this.state.environment, funcName, urlParm);

        try {
            const response = await fetch(uri, {
                method: 'GET',
                headers: this.state.headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            const output = JSON.parse(data);
            const statusCode = output.statusCode;

            if (statusCode === 200) {
                return output.body;
            } else {
                const errorObj = {
                    function: funcName,
                    subProcess: this.state.subProcess,
                    status: statusCode,
                    message: output.body.message,
                    errorObject: urlParm
                };
                this.processErrorReturn(errorObj);
            }

        } catch (error) {
            console.error("Fetch error in loadInvestmentMonthly:", error);
            const errorObj = {
                function: funcName,
                subProcess: this.state.subProcess,
                status: "network-error",
                message: error.message,
                errorObject: urlParm
            };
            this.processErrorReturn(errorObj);
        }
    }
  
    getCurrentPriceForInvestments(){
        let currentPriceArr = [];
        for (let i=0; i<this.investmentMonthlyData.length; i++){
            const monthlyData = this.investmentMonthlyData[i];
            const currentPriceObj = 
                {investShortName: monthlyData.investShortName, currentPrice: monthlyData.closingPrice};
            currentPriceArr.push(currentPriceObj);
        }
        
        if (!this.investmentMasterArr){
            this.investmentMasterArr = this.props.gameInfo.investmentMaster;
        }
        
        if (!this.gameInvestments.length){
            this.gameInvestments = this.props.gameInfo.gameInvestments;
        }
        for (let i=0; i<this.investmentMasterArr.length; i++){
            const shortName = this.investmentMasterArr[i].investShortName;
            const currentPriceObj = currentPriceArr.find(elem => elem.investShortName === shortName);
            if (currentPriceObj){
                this.investmentMasterArr[i] = {...this.investmentMasterArr[i], 
                    currentPrice: currentPriceObj.currentPrice}
            }
            let eligibleForCouponsDividends = false;
            if ((this.investmentMasterArr[i].bondInfo && 
                    this.investmentMasterArr[i].bondInfo.coupon === true) ||
                (this.investmentMasterArr[i].dividendInfo && 
                    this.investmentMasterArr[i].dividendInfo.dividend === true)){
                    eligibleForCouponsDividends = true;
            }
            this.setGameInfo(eligibleForCouponsDividends, "eligibleForCouponsDividends");
        }
        this.summaryValueArr = [];
        
        this.summaryValueArr = createInvestmentSummaryArr(this.gameInvestments, this.investmentMasterArr,
            currentPriceArr, this.state.gameInfo.gameData.startGameDate, 
            this.state.gameInfo.gameData.currentGameDate );
        this.setGameInfo(this.gameInvestments, "gameInvestments");
        this.setGameInfo(this.investmentMasterArr, "investmentMaster");
        this.setGameInfo(false, "refreshInvestments");
        this.setGameInfo(this.summaryValueArr, "summaryInvestment");
        if (this._isMounted === true){
            this.setState({gameInvestmentsLoaded: true});
        }
    }

  updateUnlockedFeatures(){
        this.setGameInfo(this.unlockedFeatures, 'gameData', "unlockedFeatures");
        this.bodyObj = {
            "currentCash": this.state.gameInfo.gameData.currentCash,
            "unlockedFeatures": this.unlockedFeatures,
            "iconTable": this.state.gameInfo.gameData.iconTable
        };
        const funcName = "updateUnlockedFeatures";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)})
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   //  update of gameData successful
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                    this.processErrorReturn(errorObj);
                }
            });
            }
        });
    }
    
    checkDataAccuracy(dataObj){
        const dataCompareObj = beforeAfterCompare(dataObj.dataType, dataObj.beforeObj, dataObj.afterObj);
        if (dataCompareObj.dataValid === false){
            let cardTitle = "";
            if (dataObj.cardTitle ){
                cardTitle = dataObj.cardTitle;
            }
            const errorDataObject = {processName: dataObj.processName, paragraphName: dataObj.paragraphName, 
                dataType: dataObj.dataType, cardTitle: cardTitle, beforeObject: dataCompareObj.beforeObj, 
                afterObject: dataCompareObj.afterObj, dataSubTypeArr: dataCompareObj.dataSubTypeArr};
            const errorMessage = "Discrepancy found in before/after compare of redux vs. mongo.";
            this.generalErrorLog(errorMessage, errorDataObject);
        }
    }

    generalErrorLog(errorDesc, dataObject) {
        if (!dataObject){
            dataObject = {currentCard: this.gameInfo.currentCard,
                currentCash: this.gameInfo.gameData.currentCash,
                assetTable: this.gameInfo.gameData.assetTable,
                expenseTable: this.gameInfo.gameData.expenseTable,
                loanTable: this.gameInfo.gameData.loanTable,
                conditionsTable: this.gameInfo.gameData.conditionsTable};
        }
        const message = errorDesc;
        const errorObj={function: "GeneralError", subProcess: this.state.subProcess, 
            status: 999, message: message, errorObject: dataObject, silentAlert: true};
        this.processErrorReturn(errorObj);
    }

    processErrorReturn(errorObj){
        this.addRecordToLogfile(errorObj);
        if (!errorObj.silentAlert || errorObj.silentAlert === false){
            alert ("Uh oh!  Something unexpected has occurred " +
                "error has been logged and will be addressed. " +
                "For now click OK, then return to the process " +
                "where you were and try again.");
            this.onNavigate("");
        }
    }

    addRecordToLogfile(errorObj){
        const headers=setHeadersForFetch();
        if (errorObj.status === 250){
            errorObj.message = "No record found";
        }
        let subProcess = "";  
        if (!errorObj.subProcess){
            subProcess = "unknown"
        }else{
            subProcess = errorObj.subProcess;
        }
        if (!errorObj.errorObject){
            errorObj.errorObject = {};
        }
        const logFileBody =  {
            mainProcess: "GameView",
            subProcess: subProcess,
            function: errorObj.function,
            status: errorObj.status,
            message: errorObj.message,
            errorObj: errorObj.errorObject
        }
        console.log("logFileBody is: ", logFileBody)
        const urlParm = "";
        const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
        fetch (uri,  
            {method:'POST',
                headers: headers,
                body: JSON.stringify(logFileBody)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            console.log("logfile create was successful");
                        }else{
                            console.log("Response from save log file not valid!" +
                            " status is: ", output.statusCode,
                            " message is: ", output.body);
                           alert ("Response from save log file not valid!");
                               
                        }
                });
                
            }
        });
      
    }
    
}

export default  connect(mapStateToProps, mapDispatchToProps)(
    withRouterCompat(GameView));